/**
 * 営業時間時間1日最大枠数
 */
export const ORGANIZATION_BUSINESS_HOUR_MAX_COUNT = 4;

export const DAY_TYPES = [
  { key: 'sunday', label: '日曜日', shortLabel: '日' },
  { key: 'monday', label: '月曜日', shortLabel: '月' },
  { key: 'tuesday', label: '火曜日', shortLabel: '火' },
  { key: 'wednesday', label: '水曜日', shortLabel: '水' },
  { key: 'thursday', label: '木曜日', shortLabel: '木' },
  { key: 'friday', label: '金曜日', shortLabel: '金' },
  { key: 'saturday', label: '土曜日', shortLabel: '土' },
  { key: 'holiday', label: '祝祭日', shortLabel: '祝' },
] as const;

export const HOUR_OPTIONS = [
  '--',
  ...Array.from({ length: 25 }, (_, i) => i.toString().padStart(2, '0')),
];
export const MINUTE_OPTIONS = ['--', '00', '15', '30', '45'];

export type TimeRange = {
  organizationBusinessHourId?: string;
  startHour: string;
  startMinute: string;
  endHour: string;
  endMinute: string;
};

export const EMPTY_TIME_RANGE: TimeRange = {
  startHour: '--',
  startMinute: '--',
  endHour: '--',
  endMinute: '--',
};
